import React, { useState, useEffect, useRef } from "react";
// redux
import Swal from "sweetalert2";
import {
  createSearchParams,
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "../../redux/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";

import "./loanform.css";
import "./AdditonalDoc.css";
import {
  getPreCibilData,
  resetLoading,
  uploadCibilStatement,
} from "../../redux/slices/loan";
import { preCibilValidator } from "../../Validations/loan/preCibilValidator";
import LoadingScreen from "../LoadingScreen";
import {
  faArrowLeftLong,
  faCircleNotch,
  faPaperPlane,
  faTriangleCircleSquare,
} from "@fortawesome/free-solid-svg-icons";
import useAuth from "./../../hooks/useAuth";
import ViewPDFModal from "./../ViewPDFModal";
const PreCibilQualification = () => {
  const { user } = useAuth();
  const { isLoading, loanData, isSaved, prevData, prevSaved } = useSelector(
    (state) => state.loan
  );
  const inputRef = useRef(null);
  const [flag, setFlag] = useState(false);
  const [flagDisable, setFlagDisable] = useState(true);
  const [showFileViewer, setShowFileViewer] = useState(false);
  // const [currentFile, setCurrentFile] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [attachmentPreview, setAttachmentPreview] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  let [rows, setRows] = useState([
    {
      promoter_director: "",
      percentage: "",
      addressPromo: "",
      contactPromo: "",
      panPromo: "",
      driving_licence: "",
      passport: "",
      ration_card: "",
    },
  ]);
  const initialState = {
    company_name: "",
    pan: "",
    registration_number: "",
    cin: "",
    date_of_incorporation: "",
    cibil_rank: "",
    location_type: "",
    address: "",
    first_reported_date: "",
    last_reported_date: "",
    promoter_name: "",
    percentage_holding: "",
    bank: "",
    loan_details: "",
    sanctioned_amount: "",
    status: "",
    credit_last_reported_date: "",
    recent_payment_history: "",
    details_on_pg_no: "",
  };
  const [formData, setFormData] = useState(initialState);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cart_id = searchParams.get("cart_id");
  // Get ID from URL
  const params = useParams();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    control,
  } = useForm({
    mode: "all",
    resolver: yupResolver(preCibilValidator),
    defaultValues: {},
  });

  const [selectedFile, setSelectedFile] = useState([]);

  const handleAddClick = () => {
    setRows([
      ...rows,
      {
        promoter_director: "",
        percentage: "",
        addressPromo: "",
        contactPromo: "",
        panPromo: "",
        driving_licence: "",
        passport: "",
        ration_card: "",
      },
    ]);
  };

  const handleRemoveSpecificRow = (idx) => {
    setFlag(true);
    const tempRows = [...rows]; // to avoid  direct state mutation
    tempRows.splice(idx, 1);
    setRows(tempRows);
  };

  const handleInputChange = (e, idx) => {
    rows = [...rows];
    rows[idx] = {
      ...rows[idx],
      [e.target?.name]: e?.target?.value,
    };
    setRows(rows);
  };

  const onInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleFileChange = (e) => {
    for (const file of e.target.files) {
      if (!file.name.match(/\.(jpeg|pdf|jpg|png)$/)) {
        Swal.fire({
          icon: "error",
          text: "Please select valid file(Jpg,Jpeg,Png,Pdf).",
        });
        return false;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // setFiles((imgs) => [...imgs, reader.result]);
        // setSelectedFile((imgs) => [
        //   ...imgs,
        //   {
        //     filename: file.name,
        //     filedata: reader.result,
        //   },
        // ]);
        setAttachmentPreview(file.name);
        setAttachment({
          filename: file.name,
          filedata: reader.result,
        });
      };
      reader.onerror = () => {};
      setErrorFlag(false);
    }
  };

  const handleSubmitForm = async (data) => {
    dispatch(
      uploadCibilStatement({
        ...data,
        // related_parties: rows,
        loanId: searchParams.get("loanId"),
        ...attachment,
      })
    );
  };

  const handleFileRemove = (idx) => {
    if (window.confirm("Do you really want to delete this file?")) {
      let tempFiles = [...selectedFile];
      // let tempFiles = files.slice(0, idx - 1).concat(files.slice(idx, files.length));
      tempFiles.splice(idx, 1);
      setSelectedFile(tempFiles);
      // files.filter(item => item !== valueToRemove)
    }
  };
  const handleOpenFileViewer = (url) => {
    setShowFileViewer(true);
    // setCurrentFile(url);
  };
  // useEffect(() => {
  //   window.history.pushState(null, null, window.location.pathname);
  //   window.addEventListener("popstate", onBackButtonEvent);

  //   return () => {
  //     window.removeEventListener("popstate", onBackButtonEvent);
  //   };
  // }, []);

  // function onBackButtonEvent(event) {
  //   event.preventDefault();
  //   window.history.pushState(null, null, window.location.pathname);
  // }

  useEffect(() => {
    if (
      isSaved &&
      attachmentPreview !== null &&
      attachmentPreview !== undefined &&
      attachmentPreview !== ""
    ) {
      Swal.fire({
        icon: "success",
        text: `Cibil data submitted successfully.`,
      });
      dispatch(resetLoading());
      if (searchParams.get("cart_id") && searchParams.get("loanId")) {
        navigate({
          pathname: "/loanprocess/pre-qualification-bank-statement",
          search: `?${createSearchParams({
            cart_id: searchParams.get("cart_id"),
            loanId: searchParams.get("loanId"),
          })}`,
        });
      } else {
        if (searchParams.get("loanId") !== undefined) {
          navigate({
            pathname: "/loanprocess/pre-qualification-bank-statement",
            search: `?${createSearchParams({
              loanId: searchParams.get("loanId"),
            })}`,
          });
        }
      }
      // navigate({
      //   pathname: "/pre-qualification-bank-statement",
      //   search: `?${createSearchParams({
      //     loanId: searchParams.get("loanId"),
      //   })}`,
      // });

      dispatch(resetLoading());
      // dispatch(getPreQualificationDocument(searchParams.get("loanId")));
    }
  }, [isSaved]);

  useEffect(() => {
    setFormData({
      ...formData,
      pan: user?.addition_info?.pan_number,
    });
    dispatch(getPreCibilData(searchParams.get("loanId")));
  }, []);

  useEffect(() => {
    if (prevData) {
      setAttachmentPreview(prevData?.company_information?.attachment_name);
    }
  }, [prevData]);

  const handleRemove = () => {
    inputRef.current.value = null;
    setAttachment(null);
    setAttachmentPreview("");
  };
  // if (isLoading) {
  //   return <LoadingScreen />;
  // }
  return (
    <>
      <form
        className="row"
        onSubmit={handleSubmit(handleSubmitForm)}
        encType="multipart/form-data"
      >
        <div className="card p-0">
          <div className="card-header py-4 text-center">
            <h4 className="fw-500">Pre-Qualification Process</h4>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-lg-12">
                <div className="loan_step">
                  <div>
                    <p>
                      {" "}
                      <span>1</span> Loan Application Form
                    </p>
                  </div>
                  <a href="#">
                    <p className="active">
                      {" "}
                      <span>2</span> Document submission
                    </p>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <h4 className="heading_form mb-3">Cibil information</h4>
            </div>
            <div className="col-lg-12">
              <ul className="steps-wrap mb-4">
                <li className="step active">
                  <span className="icon">1</span>
                  <span className="text">Step 1</span>
                </li>
                {/* <!-- step.// --> */}
                <li className="step active">
                  <span className="icon">2</span>
                  <span className="text">Step 2</span>
                </li>
                {/* <!-- step.// --> */}
                <li className="step">
                  <span className="icon">3</span>
                  <span className="text">Step 3</span>
                </li>
                {/* <!-- step.// --> */}
                <li className="step">
                  <span className="icon">4</span>
                  <span className="text">Step 4</span>
                </li>
                <li className="step">
                  <span className="icon">5</span>
                  <span className="text">Step 5</span>
                </li>
                {/* <!-- step.// --> */}
              </ul>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <label>
                    Cibil Score Statement{" "}
                    <i
                      className="fas fa-question-circle fs-14"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Most recent 2 years"
                    ></i>
                  </label>
                  <br />
                  {/* <p>Cibil file</p> */}
                  {/* <div className="upload-btn-wrapper d-block mt-4">
                    <button className="btn">
                      <i className="fas fa-cloud-upload-alt"></i> Upload a file
                      <input
                        type="file"
                        name="file"
                        {...register("file")}
                        className={`${errors?.file ? "is-invalid" : ""}`}
                        accept="application/pdf"
                        onChange={handleFileChange}
                      />
                    </button>
                    {errorFlag && (
                      <p className="text-danger">Please upload a file</p>
                    )}
                    <div className="upload_doc_group mt-3 mb-2 upload-attachment">
                      {attachmentPreview && (
                        <div className="upload_card my-1 d-flex justify-content-between align-items-center">
                          <div className="upload_card_info">
                            <p>{attachmentPreview}</p>
                          </div>
                          <div className="upload_card_close">
                            <i className="far fa-check-circle fs-20 text-success"></i>
                          </div>
                        </div>
                      )}
                    </div>
                  </div> */}
                  <div className="card upload-card mt-3">
                    <div className="card-body">
                      <div className="kb-data-box">
                        <div className="kb-file-upload">
                          <div className="file-upload-box">
                            <input
                              type="file"
                              name="file"
                              {...register("file")}
                              className={`file-upload-input ${
                                errors?.file ? "is-invalid" : ""
                              }`}
                              ref={inputRef}
                              id="fileupload"
                              onChange={handleFileChange}
                            />
                            <span>
                              Drag and drop or{" "}
                              <span className="file-link">
                                Choose your files{" "}
                              </span>
                            </span>
                            <i
                              className="fas fa-question-circle fs-14"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Select file from drop down"
                            ></i>
                          </div>
                        </div>
                        {attachmentPreview ? (
                          <div className="kb-attach-box">
                            <hr />
                            {attachmentPreview && (
                              <div className="file-atc-box">
                                {attachmentPreview?.match(
                                  /.(jpg|jpeg|png|gif|svg)$/i
                                ) ? (
                                  <div className="file-image">
                                    {" "}
                                    <img
                                      src={attachmentPreview?.fileimage}
                                      alt=""
                                    />
                                  </div>
                                ) : (
                                  <div className="file-image">
                                    <i className="far fa-file-alt"></i>
                                  </div>
                                )}
                                <div className="file-detail">
                                  <h6>{attachmentPreview}</h6>
                                  {/* <p>
                                  <span>Year : {currYear}</span>
                                </p> */}
                                  <div className="file-actions mt-1">
                                    <a
                                      className="file-action-btn"
                                      onClick={handleRemove}
                                    >
                                      <i
                                        className="far fa-trash-alt fs-20 text-danger"
                                        style={{
                                          verticalAlign: "inherit",
                                        }}
                                      ></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="text-danger">
                    {errors.financial_statement?.message}
                  </p>
                </div>
              </div>
            </div>
            {/* {flagDisable &&
              prevSaved &&
              prevData &&
              prevData?.company_information && (
                <div className="col-md-12">
                  <label htmlFor="tx_dz" style={{ marginTop: "30px" }}>
                    Documents
                  </label>
                  <div className="upload_doc_group mt-3 mb-2 upload-attachment">
                    <div className="upload_card my-1 d-flex justify-content-between align-items-center">
                      <div className="upload_card_info">
                        <a
                          href="#"
                          onClick={() =>
                            handleOpenFileViewer(
                              prevData?.company_information?.attachment_url
                            )
                          }
                        >
                          {prevData?.company_information?.attachment_type ===
                          "application/pdf" ? (
                            <div className="d-flex align-items-center">
                              <img
                                src={`data:image/png;base64,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`}
                                style={{
                                  objectFit: "contain",
                                  width: "3rem",
                                  height: "3rem",
                                }}
                                alt={`Default PDF`}
                              />
                              <p>
                                {prevData?.company_information?.attachment_name}
                              </p>
                            </div>
                          ) : (
                            <img
                              src={
                                prevData?.company_information?.attachment_url
                              }
                              alt={
                                prevData?.company_information?.attachment_name
                              }
                              style={{ objectFit: "contain" }}
                            />
                          )}
                        </a>
                        <ViewPDFModal
                          url={currentFile}
                          show={showFileViewer}
                          onHide={() => setShowFileViewer(false)}
                        />
                      </div>

                      <div className="upload_card_close">
                        <button
                          className="btn btn-sm"
                          onClick={() => setFlagDisable(false)}
                        >
                          <i
                            className="far fa-trash-alt fs-20 text-danger"
                            style={{ verticalAlign: "inherit" }}
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
          </div>
        </div>
        <div className="text-center mt-3">
          <Link
            // to={`/pre-qualification-financial?loanId=${searchParams.get(
            //   "loanId"
            // )}`}
            to={
              cart_id !== null && cart_id !== undefined && cart_id !== ""
                ? `/loanprocess/pre-qualification-financial?cart_id=${cart_id}&loanId=${searchParams.get(
                    "loanId"
                  )}`
                : `/loanprocess/pre-qualification-financial?loanId=${searchParams.get(
                    "loanId"
                  )}`
            }
            className="btn btn-primary mx-3"
          >
            <i className="fas fa-arrow-alt-circle-left"></i> Previous
          </Link>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={
              isLoading ||
              attachmentPreview === null ||
              attachmentPreview === undefined ||
              attachmentPreview === ""
            }
          >
            {isLoading ? (
              <>
                <FontAwesomeIcon icon={faCircleNotch} spin size="lg" /> Next
                <i className="fas fa-arrow-alt-circle-right"></i>
              </>
            ) : (
              <>
                Next <i className="fas fa-arrow-alt-circle-right"></i>
              </>
            )}
          </button>
        </div>
      </form>
    </>
  );
};

export default PreCibilQualification;
